import { filter, find, includes, pluck, prop, propEq } from "ramda";
import { IdNamePair } from "./types";
import { ensureArray } from "ramda-adjunct";

export const idToName = (ids: string[], options: IdNamePair[]) => {
  const filteredOptions = filter((option) => includes(String(option.id), ensureArray(ids).map(String)), options);
  return pluck("name", filteredOptions);
};

export const findNameById = (id: string, options: IdNamePair[]) => {
  const foundObject = find(propEq("id", id), options ?? []);
  const name = foundObject ? prop("name", foundObject) : null;
  return name;
};
